module.exports = __webpack_public_path__ + "img/togo.b5aba65b.svg";